import request from 'oc-request';
import PopupMaster from '../popupMaster';

/**
 * Отправка формы.
 */
function doMagic(event) {
	const formItem = this;
	request.sendForm(formItem, 'genericForm::onFormSubmit', {
	    success: (res) => {
	    	const obPopup = new PopupMaster(`[data-nika-magic-form-success]`);
	    	obPopup.show();
			const reachGoal = formItem.dataset.reachGoalCtx || formItem.dataset.reachGoal;

			if (window['ym'] && reachGoal) {
				ym('89142018', 'reachGoal', reachGoal);
			}
	    },
	    error: (errorText) => {
	    	const obPopup = new PopupMaster(`[data-nika-magic-form-error]`);
	    	obPopup.show();
	    	document.querySelector(`[data-nika-magic-form-error-text]`).textContent = errorText;
	    },
	});
	event.preventDefault();
}

/**
 * Иницализация: навешивание отслеживания отправки формы.
 */
function init() {
	const attributeName = 'data-nika-magic-form';
    const formsList = document.querySelectorAll(`[${attributeName}]`);
	formsList.forEach(function(formItem) {
		formItem.addEventListener('submit', doMagic, false);
	});
}

init();